<template>
  <div class="app flex-row align-items-center login-form">
    <div class="container">
      <b-row class="row justify-content-center">
        <!-- LOGIN PAGE -->
        <b-col sm="12" md="6">
          <b-card-group>
            <!--Login-->
            <b-card class="p-4">
              <div class="bottom-15">
                <h1>Login</h1>
                <p>Sign In to your account</p>
              </div>
              <b-form id="form-login" @submit.prevent="processLogin">
                <b-form-group>
                  <p v-show="isFailed" class="text-danger" ref="errorMsg"></p>
                </b-form-group>
                <b-input-group class="mb-1">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fal fa-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <!--Notice: Use email to login, email is username -->
                  <b-form-input type="text" name="email" placeholder="Email"
                                required="required" v-model="loginData.email"></b-form-input>
                  <!--<div class="invalid-feedback" v-if="!$v.loginData.email.required && $v.loginData.email.$dirty">Username is required</div>-->
                </b-input-group>
                <b-input-group class="mb-1">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fal fa-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" name="password"
                                placeholder="Password" required="required"
                                v-model="loginData.password"></b-form-input>
                  <!--<div class="invalid-feedback" v-if="!$v.loginData.password.required && $v.loginData.password.$dirty">Password is required</div>-->
                </b-input-group>
                <b-input-group class="mb-1" v-if="isUse2FA">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="fal fa-key"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" name="otp" placeholder="OTP" required="required"
                                v-model="loginData.otp"></b-form-input>
                </b-input-group>
                <b-form-checkbox
                        id="is-use-2fa"
                        v-model="isUse2FA"
                        name="is-use-2fa"
                        class="mt-3"
                >
                  Using Two Factor Auth
                </b-form-checkbox>
                <b-row class="d-flex align-items-center mt-3">
                  <b-col class="col-6">
                    <b-button type="submit" class="px-4" variant="primary" id="login-btn"><strong>Login</strong>
                    </b-button>
                  </b-col>
<!--                  <b-col class="col-6 text-right">-->
<!--                    <router-link :to="{ name: 'Home' }">Forgot password?</router-link>-->
<!--                    <router-link :to="{ name: 'Home' }" class="d-none d-md-block d-lg-none">Register</router-link>-->
<!--                  </b-col>-->
                </b-row>
              </b-form>
            </b-card>
            <!--Register-->
<!--            <b-card class="text-white bg-primary py-5 bv-d-md-down-none">-->
<!--              <div class="text-center">-->
<!--                <h2>Sign up</h2>-->
<!--                <p class="mt-4">If you do not have an account yet, please create your own.</p>-->
<!--                <router-link class="btn btn-primary register-btn mt-4" :to="{ name: 'Home' }">-->
<!--                  <strong>Register Now!</strong>-->
<!--                </router-link>-->
<!--              </div>-->
<!--            </b-card>-->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { api } from '@sfs-projects/sfs-fc-api-sdk';
  import router from '../../router';
  export default {
    name: 'Login',
    data () {
      return {
        loginData: {
          email: null,
          password: null,
          otp: null,
        },
        isUse2FA: false,
        isFailed: false
      }
    },
    // validations: {
    //   loginData: {
    //     email: {
    //       required
    //     },
    //     password: {
    //       required
    //     }
    //   }
    // },
    // mixins: [vToast],
    methods: {
      // processRegister () {
      //   const registerData = {
      //     "Email": "phucnguyen@hdwebsoft.com",
      //     "Password": "123456",
      //     "ConfirmPassword": "123456",
      //     "Role": "Admin",
      //     "Status": "Active"
      //   }
      //   api.Auth.register(registerData).then(function (res) {
      //     console.log('res register: ', res);
      //   })
      //   console.log('registerData: ', registerData);
      // },
      processLogin () {
        // Todo: go to login again if re-open browser
        api.Auth.login(this.loginData.email, this.loginData.password, this.loginData.otp)
        .then((res) => {
          if(res.success) {
            router.push({name: 'Home'});
          } else {
            this.$bvToast.toast(res.message, {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
          }
        })
        .catch((err) => {
          this.$bvToast.toast(err.message, {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
